<template>
  <div class="parent-no-data">
    <div class="no-data-icon">
      <BaseIcon :name="iconName" width="48px" height="48px" />
      <div class="inner-text">
        {{ message || $t('noData') }}
      </div>
      <template>
        <slot name="extraText">
</slot>
      </template>
    </div>
  </div>
</template>

<script>
/**
 * Displayed on an Component which does not have any data
 */
export default {
  name: 'NoData',
  props: {
    /**
     * Text displayed below no data icon
     */
    message: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: 'noData',
    },
  },
  data() {
    return {
      open: false,
    };
  },
  mounted() {},
  methods: {
    setDefault(desiredOption = null) {},
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.no-data-icon {
  width: 100%;
}
.parent-no-data {
  display: flex;
  align-items: center;
  text-align: center;
  height: 100%;
}

.inner-text {
  font-family: $semi-bold;
  font-size: 1.25em;
  color: $color-brand-accent;
}
</style>
